import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({providedIn: 'root'})
export class FusePlatformService
{
    osName = 'os-unknown';

    /**
     * Constructor
     */
    constructor(@Inject(PLATFORM_ID) private platformId: Object)
    {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        // Windows
        if (navigator.userAgent.includes('Win'))
        {
            this.osName = 'os-windows';
        }

        // Mac OS
        if (navigator.userAgent.includes('Mac'))
        {
            this.osName = 'os-mac';
        }

        // Unix
        if (navigator.userAgent.includes('X11'))
        {
            this.osName = 'os-unix';
        }

        // Linux
        if (navigator.userAgent.includes('Linux'))
        {
            this.osName = 'os-linux';
        }

        // iOS
        // You may want to keep this._platform.IOS if it works for you, or refactor similarly
        // Android
        // Same as above
    }

}
